// Modules
import { useOutlet } from "react-router-dom";
import { useRetrospectiveClaimPage } from "containers/RetrospectiveClaim/useRetrospectiveClaimPage";

// Components
import { Button as ANTButton } from "antd";
import ExpandedRowTable from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import HeaderStatusInfo from "components/molecules/HeaderStatusInfo/HeaderStatusInfo";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import { Head } from "components/molecules/Head/Head";
import CollapsibleTable from "components/atoms/CollapsibleTable/CollapsibleTable";
import Spinner from "components/atoms/Spinner/Spinner";

// styles
import styles from "containers/RetrospectiveClaim/retrospectiveClaim.module.css";

// Constants
import { RETRO_CLAIM as Constants, PageTitles } from "constants/global";
import { RETRO_CLAIM_COLUMN_DATA } from "constants/retroClaimData";

const RetrospectiveClaimPage = () => {
	const childRouteElement = useOutlet();
	const componentProps = useRetrospectiveClaimPage();

	const { loading, currentExpandedGroup, handleExpandRows, getGroupHeader, generateCols, updatedClaimGroupList, statusBarInfo, defaultClaimGroupKey, handleCreateClaim } =
		componentProps;

	if (loading) {
		return <Spinner />;
	}

	return (
		<div>
			<Head>{PageTitles.RETROSPECTIVE_CLAIM}</Head>
			{!childRouteElement && (
				<div className="relative">
					<div className={styles?.root}>
						<HeaderStatusInfo message={statusBarInfo.message} background={statusBarInfo.background} />
						<PageTitle showBackIcon={false} title={Constants.PAGE_TITLE} subTitle={Constants.PAGE_SUBTITLE} />

						<div className={styles?.btn_wrapper}>
							<ANTButton className={styles?.createClaimButton} type="primary" onClick={handleCreateClaim}>
								{Constants.BUTTON_LABELS.CREATE_CLAIM.label}
							</ANTButton>
						</div>
					</div>
					{updatedClaimGroupList &&
						updatedClaimGroupList?.map((groupItem, index) => {
							return (
								<div className={styles.table_container} key={groupItem.perm_id}>
									<CollapsibleTable
										defaultExpandedGroupKey={defaultClaimGroupKey}
										handleExpandRows={handleExpandRows}
										currentExpandedGroup={currentExpandedGroup}
										keyIndex={index}
										rowClassName="collapsible-table"
										showHeader={false}
										generateCols={generateCols}
										groupItem={[groupItem]}
										generateData={getGroupHeader}
										expandedRowElement={() => <ExpandedRowTable groupDetails={groupItem} columnHeaderData={RETRO_CLAIM_COLUMN_DATA} rowsPerPage={Constants.DEFAULT_ROW_PER_PAGE} />}
									/>
								</div>
							);
						})}
				</div>
			)}
			{childRouteElement}
		</div>
	);
};

export default RetrospectiveClaimPage;
